import CTLBooleanCell from "application/components/CTLBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { adminMenus } from "globals/configuration/admin";
import formControl from "globals/form-control";

const Attributes = {
  formSize: "lg",
  enableAddButton: true,
  settingsMode: false,
  enableAdvanceSearch: true,

  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  create: "/userCoordinate/create",
  update: "/userCoordinate/update",
  list: "/userCoordinate/list",
  delete: "/userCoordinate/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Extension Name",
      accessor: "extensionName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Extension No",
      accessor: "extensionNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      controlType: "select",
      filterControlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "extension",
        keyDescription: "extension",
        values: [],
        url: "/extensions/listAllExtensionPhone",
      },
    },
    {
      Header: "User Name",
      accessor: "username",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width: 4,
      controlType: "select",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "username",
        keyDescription: "username",
        values: [],
        url: "/userRole/listAll/users",
      },
    },
    {
      Header: "Zone",
      accessor: "zone",
      displayInList: true,
      allowInForm: true,
      sortDisable: true,

      allowFilter: false,
      dataType: "string",
      controlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "description",
        keyDescription: "description",
        values: [],
        url: "/userZone/listAll",
      },
    },
    {
      Header: "Department",
      accessor: "department",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,

      dataType: "string",
      controlType: "select",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "code",
        keyDescription: "description",
        values: [],
        url: "/department/listAll",
      },
    },

    {
      Header: "Device Id",
      accessor: "deviceId",
      displayInList: true,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      isUserGenerated: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Geo Cordinate X",
      accessor: "geoX",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Geo Cordinate Y",
      accessor: "geoY",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 4,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Name",
      accessor: "name",
      displayInList: false,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Blood Group",
      accessor: "bloodgroup",
      displayInList: false,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Home Address",
      accessor: "haddredd",
      displayInList: false,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Office Address",
      accessor: "oaddress",
      displayInList: false,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Primary Emergency Contact No",
      accessor: "pecnumber",
      displayInList: false,
      allowInForm: true,
      width: 4,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Secondary Emergency Contact No",
      accessor: "secnumber",
      displayInList: false,
      width: 4,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Primary Emergency Contact Person",
      accessor: "pecname",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      width: 4,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Secondary Emergency Contact Person",
      accessor: "secname",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      width: 4,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Medical Details",
      accessor: "meddetails",
      displayInList: false,
      width: 4,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Connected",
      accessor: "connected",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "boolean",
      width: 4,
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
